/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { HousewareSoapLiquidIcon16Light } from './HousewareSoapLiquidIcon16Light';
import { HousewareSoapLiquidIcon16Regular } from './HousewareSoapLiquidIcon16Regular';
import { HousewareSoapLiquidIcon16Solid } from './HousewareSoapLiquidIcon16Solid';
import { HousewareSoapLiquidIcon20Light } from './HousewareSoapLiquidIcon20Light';
import { HousewareSoapLiquidIcon20Regular } from './HousewareSoapLiquidIcon20Regular';
import { HousewareSoapLiquidIcon20Solid } from './HousewareSoapLiquidIcon20Solid';
import { HousewareSoapLiquidIcon24Regular } from './HousewareSoapLiquidIcon24Regular';
import { HousewareSoapLiquidIcon24Solid } from './HousewareSoapLiquidIcon24Solid';
import { HousewareSoapLiquidIcon32Regular } from './HousewareSoapLiquidIcon32Regular';
import { HousewareSoapLiquidIcon64Regular } from './HousewareSoapLiquidIcon64Regular';
var sizes = {
    16: {
        light: HousewareSoapLiquidIcon16Light,
        regular: HousewareSoapLiquidIcon16Regular,
        solid: HousewareSoapLiquidIcon16Solid,
    },
    20: {
        light: HousewareSoapLiquidIcon20Light,
        regular: HousewareSoapLiquidIcon20Regular,
        solid: HousewareSoapLiquidIcon20Solid,
    },
    24: {
        regular: HousewareSoapLiquidIcon24Regular,
        solid: HousewareSoapLiquidIcon24Solid,
    },
    32: {
        regular: HousewareSoapLiquidIcon32Regular,
    },
    64: {
        regular: HousewareSoapLiquidIcon64Regular,
    },
};
export var HousewareSoapLiquidIcon = forwardRef('HousewareSoapLiquidIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
